// src/pages/Staff/MyProfile.jsx
import React from "react";
import "./MyProfile.css";
import { useAuth } from "../../context/AuthContext";

const MyProfile = () => {
  const { role } = useAuth();

  const user = {
    name: "Peter",
    email: "peter@nagoyaseika.co.jp",
    position: "Staff",
    role: role || "user",
  };
  return (
    <div className="max-w-4xl mx-1 mt-1 rounded-xl flex overflow-hidden p-[10px]">
      <div style={{ width: '100%' }}>
        <h2 style={{ margin: 0, fontSize: 18, fontWeight: 600, marginBottom: 12 }}>マイプロフィール</h2>
        <div className="profile-card">
          <div className="avatar-placeholder">A</div>
          <div className="profile-details">
            <div><strong>氏名:</strong> {user.name}</div>
            <div><strong>メール:</strong> {user.email}</div>
            <div><strong>役職:</strong> {user.position}</div>
            <div><strong>役割:</strong> {user.role}</div>
            <div style={{ marginTop: 8, fontSize: 13, color: '#475569' }}>会社メールドメイン: <strong>nagoyaseika.co.jp</strong></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyProfile;
